import React/*, { Component }*/ from 'react';
import PropTypes from 'prop-types';
//import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { Input/*, Switch*/ } from '@progress/kendo-react-inputs';

//import { isEmpty } from '../helpers';
import DropDownContainer from './DropDownContainer';
import isPage from '../hoc/isPage';
import { AppContext } from '../context/AppContext';

class PartExceptionsSearchBox extends React.Component {

    static propTypes = {
        onSearch: PropTypes.func,
        handleSearchParamsChange: PropTypes.func,
        searchParams: PropTypes.object,
        fieldRequired: PropTypes.bool
    }

    //constructor(props) {
    //    super(props);
    //}

    render() {
        const orgType = this.context.state.orgType;
        //<div className="top-margin-15">
        //    <Button primary={true} onClick={this.props.handleSearch}>Apply</Button>
        //</div>
        //<DropDownContainer dataType="exceptions" name="selectedException" label="Exception" defaultToFirstItem={true} handleChange={this.props.handleSearchParamsChange} value={(this.props.searchParams.selectedException) ? this.props.searchParams.selectedException : { exceptionID: 0, exception: "All Exceptions" }} />

        //!DBTRANS! @m0191@ Part Number !DEVNOTE! Input field label
        //!DBTRANS! @m0259@ Vendor !DEVNOTE! Input field label
        //!DBTRANS! @m0021@ Apply !DEVNOTE! Button Label
        //!DBTRANS! @m0466@ Filters !DEVNOTE! Input field label
        //!DBTRANS! @m0467@ Dealership !DEVNOTE! Input field label
        //!DBTRANS! @m0468@ Exception !DEVNOTE! Input field label

        return (
            <form className={`search-panel shadow-box ${this.props.className}`}>

                <div className="search-controls-header">{this.props.returnLocalizedString("m0466")}</div>
                <div className="search-controls">
                    {orgType === "dealergroup" && (
                        <fieldset className="right-margin-20">
                            <DropDownContainer dataType="dealerships" name="selectedDealership" label={this.props.returnLocalizedString("m0467")} defaultToFirstItem={true} hasEmptyOption={false}
                                uiLanguage={this.props.getLanguage()}
                                handleChange={this.props.handleSearchParamsChange} value={this.props.searchParams.selectedDealership} />
                        </fieldset>
                    )}
                    <fieldset className="right-margin-20">
                        <Input required={this.props.fieldRequired} label={this.props.returnLocalizedString("m0191")} name="selectedPartNumber" type="text" onChange={this.props.handleSearchParamsChange} value={this.props.searchParams.selectedPartNumber} />
                    </fieldset>
                    {orgType === "dealergroup" && (
                        <fieldset className="right-margin-20">
                            <DropDownContainer dataType="majorVendors" name="selectedVendor" label={this.props.returnLocalizedString("m0259")} defaultToFirstItem={true}
                                uiLanguage={this.props.getLanguage()}
                                handleChange={this.props.handleSearchParamsChange} value={this.props.searchParams.selectedVendor} orgID={(this.props.searchParams.selectedDealership) ? this.props.searchParams.selectedDealership.orgID : undefined} />
                        </fieldset>
                    )}
                    {orgType === "dealer" && (
                        <fieldset className="right-margin-20">
                            <DropDownContainer dataType="majorVendors" name="selectedVendor" label={this.props.returnLocalizedString("m0259")} defaultToFirstItem={true}
                                uiLanguage={this.props.getLanguage()}
                                handleChange={this.props.handleSearchParamsChange} value={this.props.searchParams.selectedVendor} />
                        </fieldset>
                    )}
                    <fieldset className="right-margin-20">
                        <DropDownContainer required={this.props.fieldRequired} dataType="exceptions" name="selectedException" label={this.props.returnLocalizedString("m0468")} defaultToFirstItem={true}
                            uiLanguage={this.props.getLanguage()}
                            handleChange={this.props.handleSearchParamsChange} value={this.props.searchParams.selectedException} />
                    </fieldset>
                    <fieldset>
                        <Button primary={true} onClick={this.props.handleSearch}>{this.props.returnLocalizedString("m0021")}</Button>
                    </fieldset>
                </div>
            </form>
        );
    }
}

export default isPage(PartExceptionsSearchBox);
PartExceptionsSearchBox.contextType = AppContext;



// WEBPACK FOOTER //
// ./src/components/PartExceptionsSearchBox.js